import { useApi } from './useApi'

const BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

export const useSalidaTokens = () => {
  const api = useApi()

  // vista: 'normal' (SalidaPublica) o 'mayores' (Portal Fácil / SalidaPublicaMayores) —
  // son dos rutas/páginas distintas que aceptan el mismo token.
  const getPublicUrl = (token, vista = 'normal') =>
    `${window.location.origin}/salida-publica${vista === 'mayores' ? '-mayores' : ''}?token=${token}`

  const getTokens = () => api.get('/api/salidas/tokens')

  const createToken = (name = 'Enlace') =>
    api.post('/api/salidas/tokens', { name })

  const revokeToken = (token) => api.del(`/api/salidas/tokens/${token}`)

  const setTokenDefaultView = (token, defaultView) =>
    api.patch(`/api/salidas/tokens/${token}/default-view`, { defaultView })

  const addSalidaToToken = (token, salidaId) =>
    api.post(`/api/salidas/tokens/${token}/salidas/${salidaId}`, {})

  const removeSalidaFromToken = (token, salidaId) =>
    api.del(`/api/salidas/tokens/${token}/salidas/${salidaId}`)

  const fetchPublicSalida = async (token) => {
    const res = await fetch(`${BASE_URL}/api/public/salida/${token}`)
    return res.json()
  }

  const getWorkedManzanas = async (token) => {
    const res = await fetch(`${BASE_URL}/api/public/salida/${token}/manzanas`)
    return res.json()
  }

  const getPendientesManzanas = async (token) => {
    const res = await fetch(`${BASE_URL}/api/public/salida/${token}/pendientes`)
    return res.json()
  }

  const postWorkRecord = async (salidaToken, payload) => {
    const res = await fetch(`${BASE_URL}/api/public/work-record`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Salida-Token': salidaToken,
      },
      body: JSON.stringify(payload),
    })
    return res.json()
  }

  const getWsUrl = (token) =>
    `${BASE_URL.replace(/^http/, 'ws')}/ws?token=${token}`

  // Imagen estática del mapa de una manzana (Portal Fácil / SalidaPublicaMayores),
  // generada por el sidecar mapa-mayores-service/. Puede no estar disponible; el
  // <img> que la consume debe manejar el evento `error`.
  const getMapaMayoresUrl = (token, terrKey, mzIdx) =>
    `${BASE_URL}/api/public/salida/${token}/mapa/${encodeURIComponent(terrKey)}/${mzIdx}.png`

  const getAdminLocations = (token) =>
    api.get(`/api/salidas/tokens/${token}/locations`)

  return {
    getPublicUrl,
    getTokens,
    createToken,
    revokeToken,
    setTokenDefaultView,
    addSalidaToToken,
    removeSalidaFromToken,
    fetchPublicSalida,
    getWorkedManzanas,
    getPendientesManzanas,
    postWorkRecord,
    getWsUrl,
    getMapaMayoresUrl,
    getAdminLocations,
  }
}
